import React, { memo } from 'react';
import { SinglelineTextField } from 'app/pages/Survey/Subject/elements';
import { useTextShortAnswer } from './hooks';

const Answer = () => {
  const textShortAnswerConfig = useTextShortAnswer();

  return <SinglelineTextField {...textShortAnswerConfig} />;
};

export default memo(Answer);
